import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.sass'],
})
export class ErrorBannerComponent implements OnInit {
  @Input() title = '';
  @Input() subtitle = '';

  constructor() {}

  ngOnInit() {}
}
